import shortid from "shortid";

export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "40%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "60%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
